import Theme from './theme';

const VocabDeckConfig = [
  {
    type: 'vocab',
    progressLabel: 'Words Seen',
    borderColor: Theme.blue,
    iconType: 'text',
    iconWidth: 40,
    backgroundColors: ['#00b8db', '#00c8e4', '#7bdef0'],
    useDisabledProp: true,
    onlyForGerman: false,
  },
  {
    type: 'gender',
    progressLabel: 'Gender Cards Seen',
    borderColor: Theme.green,
    iconType: 'icon',
    iconName: 'CubeIcon',
    iconWidth: 50,
    backgroundColors: [Theme.green, '#21ca74', '#27e082'],
    iconMarginTop: -3,
    useDisabledProp: false,
    onlyForGerman: false,
  },
  {
    type: 'plural',
    progressLabel: 'Plural Cards Seen',
    borderColor: Theme.purple,
    iconType: 'icon',
    iconName: 'PluralOutlineIcon',
    iconWidth: 55,
    backgroundColors: [Theme.purple, '#ae88ff', '#c3a6ff'],
    iconMarginTop: -3,
    useDisabledProp: false,
    onlyForGerman: true,
  },
  {
    type: 'case',
    progressLabel: 'Case Cards Seen',
    borderColor: '#F886C1',
    iconType: 'icon',
    iconName: 'CompassIcon',
    iconWidth: 65,
    background: '#F886C1',
    iconMarginTop: 0,
    iconMarginLeft: 0,
    useDisabledProp: false,
    onlyForGerman: true,
  },
  {
    type: 'synonym',
    progressLabel: 'Synonym Cards Seen',
    borderColor: '#6a9bff',
    iconType: 'icon',
    iconName: 'HandshakeIcon',
    iconWidth: 53,
    backgroundColors: ['#6a9bff', '#85adff', '#a4c3ff'],
    iconMarginTop: 3,
    useDisabledProp: false,
    onlyForGerman: true,
  },
  {
    type: 'conjugation',
    progressLabel: 'Conjugation Cards Seen',
    borderColor: Theme.red,
    iconType: 'icon',
    iconName: 'JigsawIcon',
    iconWidth: 53,
    backgroundColors: [Theme.red, '#ff7575', '#fd9594'],
    iconMarginTop: -3,
    useDisabledProp: false,
    onlyForGerman: false,
  },
  {
    type: 'number',
    progressLabel: 'Number Cards Seen',
    borderColor: Theme.orange,
    iconType: 'icon',
    iconName: 'NumbersOutlineIcon',
    iconWidth: 55,
    backgroundColors: [Theme.orange, '#faa15e', '#fbb36b'],
    webBackgroundColors: [Theme.orange, 'rgb(250 161 94)', 'rgb(251 179 107)'],
    iconMarginTop: -3,
    useDisabledProp: false,
    onlyForGerman: false,
  },
];

export default VocabDeckConfig;
